import { Component } from '@angular/core';

@Component({
  selector: 'app-incoming-orders-overview',
  templateUrl: './incoming-orders-overview.component.html',
  styleUrls: ['./incoming-orders-overview.component.scss']
})
export class IncomingOrdersOverviewComponent {

}
